import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type ControlIQPCM = "no_control" | "open_loop" | "pining" | "closed_loop";

export type ControlIQPumpControlModeChangePayload = {
  current_PCM?: number;
  previous_PCM?: number;
};

export type ControlIQPumpControlModeChangeEvent = {
  currentPCM?: ControlIQPCM;
  previousPCM?: ControlIQPCM;
};

const controlIQPumpControlModeChangeSchema = z.object({
  current_PCM: cz.permissive(z.number()),
  previous_PCM: cz.permissive(z.number()),
});

export const LID_AA_PCM_CHANGE = {
  value: 0xe6,
  name: "Control-IQ Pump Control Mode (PCM) Change",
  format: "bb..............",
  fields: ["current_PCM", "previous_PCM"],
  postprocess: rec => ({
    currentPCM: getPCM(rec.current_PCM),
    previousPCM: getPCM(rec.previous_PCM),
  }),
  schema: controlIQPumpControlModeChangeSchema,
} as const satisfies TandemEventDefinition<ControlIQPumpControlModeChangePayload, ControlIQPumpControlModeChangeEvent>;

const getPCM = (pcm?: number): ControlIQPCM | undefined => {
  switch (pcm) {
    case 0:
      return "no_control";
    case 1:
      return "open_loop";
    case 2:
      return "pining";
    case 3:
      return "closed_loop";
    default:
      return undefined;
  }
};
